import React from "react";
import FilterRadioButtons from "../forms/filter-radio-buttons";
import {  alertStatuses, channel_values, filterByAudit } from "../helper-components/data";
import { filterByTimePeriod } from "../helper-components/data";

const AlertFilter = ({ setFilterData, filterData }) => {
  const handlePerodicChange = (e) => {
    setFilterData({
      ...filterData,
      channel_values: e.target.value,
    });
    
  };
  const handleAuditChange = (e) => {
    setFilterData({
      ...filterData,
      status: e.target.value,
    });
    
  };
  return (
    <div
      menuPortalTarget={document.body}
      style={{
        minWidth: "13rem",
        zIndex: 999,
        top: "40px",
        right: "-5px",
        boxShadow: `0px 1px 3px 0px var(--popover-shadow-color)`,
      }}
      className="absolute  border border-[var(--popover-border-color)] border-solid border-1   py-3 px-2  bg-[var(--popover-bg-color)]  rounded  z-10 flex flex-col"
    >
      <span className=" text-[length:--popover-heading-font-size] font-[var(--popover-heading-font-weight)] text-[var(--popover-heading-fg-color)] whitespace-nowrap cursor-pointer border-radius px-[8px] py-[12px]">
        FILTER BY
      </span>
      <hr className="border border-EAECF0" />
      <div className="px-3 flex flex-row gap-6">
        
        <FilterRadioButtons
          name="channel_values"
          label={"Channels"}
          options={channel_values}
          handleChange={handlePerodicChange}
          value={filterData?.channel_values}
        />
        
        <FilterRadioButtons
          name="status"
          label={"Status"}
          options={alertStatuses}
          handleChange={handleAuditChange}
          value={filterData?.status}
        />
      </div>
    </div>
  );
};

export default AlertFilter;
